import { render, staticRenderFns } from "./Provider1.vue?vue&type=template&id=687bc50b&"
import script from "./Provider1.vue?vue&type=script&lang=ts&"
export * from "./Provider1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports